<template>
    <el-dialog
        title="选择人群范围(部门)"
        :visible.sync="dialogVisible"
        width="1100px"
        :close-on-click-modal="false"
        :modal="false"
        :before-close="handleClose">
        <div style="height:500px;display:flex">
            <div style="height:500px;width:30%;">
                <treeMenu
                    ref="treeMenu"
                    initId="0"
                    :showBox="true"
                    loadStyle="staticLoad"
                    style="dispaly:inline-block;"
                    @nodeClick="getNodeId"
                    @BoxClick="BoxClick"
                ></treeMenu>
            </div>
            <div style="flex:1;text-align:center;">
                <p>已选部门<span style="color:red">({{arrNames.length}}个)</span></p>
                <div style="margin-top:10px;height:480px;overflow:auto">
                    <p v-for="(item,index) in arrNames" :key="index" style="margin-top:5px">
                        {{item}}
                    </p>
                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import treeMenu from "@/components/treeMenu/index.vue";
export default {
    components: { treeMenu },
    props:{
        dialogVisible: {
            type: Boolean,
            required: true,
            default: true
        }
    },
    data(){
        return{
            arrIds:[],
            arrNames:[],
        }
    },
    methods:{
        handleClose(){
            this.$emit('visibleClose')
        },
        getNodeId(){

        },
        BoxClick(val,data){
            this.arrIds = [...new Set(this.getChildIds(data))]
            this.arrNames = [...new Set(this.getChildNames(data))]
        },
        getChildIds(arr){
            let ids = [];
            arr.forEach(i=>{
                if(i.children.length==0){
                    ids.push(i.id)
                }else{
                    ids = ids.concat(this.getChildIds(i.children))
                }
            })
            return ids
        },
        getChildNames(arr){
            let names = [];
            arr.forEach(i=>{
                if(i.children.length==0){
                    names.push(i.name)
                }else{
                    names = names.concat(this.getChildNames(i.children))
                }
            })
            return names
        },
        submit(){
            this.$emit('submit',{
                names:this.arrNames,
                ids:this.arrIds
            })
        }
    }
}
</script>
<style scoped>

</style>